import Marquee from "react-fast-marquee";
import { CLIENTS } from "@/data/content";

export default function ClientMarquee() {
  return (
    <section
      className="relative border-t border-white/10 bg-[#050505] py-16 md:py-20"
      data-testid="client-marquee-section"
    >
      <div className="mx-auto mb-10 max-w-[1600px] px-5 md:px-10">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#52525b]">
          Trusted by global leaders
        </span>
      </div>

      <Marquee speed={40} gradient={false} className="overflow-hidden">
        {CLIENTS.map((c, i) => (
          <div key={i} className="flex items-center" data-testid={`client-${i}`}>
            <span className="font-display text-4xl font-extrabold uppercase tracking-tight text-transparent md:text-7xl [-webkit-text-stroke:1px_rgba(255,255,255,0.35)]">
              {c}
            </span>
            <span className="mx-8 text-[#0033ff] md:mx-14 md:text-3xl">/</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
